import { useEffect, useState } from "react";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { fetchCustomersV2 } from "@api";
import { buildApiQuery } from "@utils";

function useDebouncedValue(value, delay = 250) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);
  return debounced;
}

export default function useMentionSearch(term, { enabled = true } = {}) {
  const trimmed = term.trim();
  const debouncedTerm = useDebouncedValue(trimmed, 250);

  const query = useQuery({
    queryKey: ["customers", "mention-search", debouncedTerm],
    queryFn: ({ signal }) =>
      fetchCustomersV2(
        buildApiQuery({ page: 1, pageSize: 20, searchTerm: debouncedTerm }),
        { signal },
      ),
    enabled,
    // Alphabetical by name (A–Z) for the account list.
    select: (res) =>
      (res?.data ?? [])
        .slice()
        .sort((a, b) => (a.name ?? "").localeCompare(b.name ?? "")),
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });

  return {
    results: query.data ?? [],
    isFetching: query.isFetching || debouncedTerm !== trimmed,
  };
}
